import React from 'react';
import styles from '../MobileDashboardPage/MobileDashboardPage.module.scss';
import { LiveDataGrid } from '../../components/LiveDataGrid';
import { ATS_TRADE_SYMBOL_SUMMARY, ATS_TRADE_MMID_SUMMARY } from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();

const ATS_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_TRADE_SYMBOL_SUMMARY);
const ATS_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_TRADE_MMID_SUMMARY);

class MobileDashboardAtsGrids extends React.PureComponent {
  render () {
    const pauseRealTimeData = false;
    return (
      <div className={styles.atsTables} >
        <LiveDataGrid
          identifier={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          ws={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.ws}
          api={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={ATS_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={ATS_TRADE_MMID_SUMMARY_CONFIG.header}
          ws={ATS_TRADE_MMID_SUMMARY_CONFIG.ws}
          api={ATS_TRADE_MMID_SUMMARY_CONFIG.api}
          downloadApi={ATS_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ATS_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={ATS_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />
      </div>
    );
  }
}

export default MobileDashboardAtsGrids;
export const MemoizedMobileDashboardAtsGrids = React.memo(MobileDashboardAtsGrids);